export const PERMISSION_CODES = {
  changeSupport: { description: 'Change Support information (support email, bug email)', code: '01' },
  viewPeoplesAudit: { description: 'View other peoples audit', code: '02' },
  editProfile: { description: 'Edit other peoples profile', code: '03' },
  assignRoles: { description: 'Assign roles', code: '04' },
  viewCreateEditRoles: { description: 'View/Create/Edit roles (i.e. edit permissions and role name)', code: '05' },
  viewProfile: { description: 'View full profile', code: '06' },
  viewEditLists: { description: 'View/Edit Lists', code: '07' },
  useUpdateButton: { description: 'View and use Update button in View Profile', code: '08' },
  exportProfiles: { description: "Export other people's profiles", code: '09' },
  viewArchivedProfiles: { description: 'View archived profiles', code: '10' },
  advancedSearch: {
    description:
    'View and use Advanced Search in Profiles',
    code: '11'
  },
  viewReport: {
    description: 'View report section',
    code: '12'
  },
  viewMyTeamPage: {
    description: 'View "My team" page',
    code: '13'
  }
}

export const DEFAULT_PERMISSIONS = [
  PERMISSION_CODES.viewProfile.code,
  PERMISSION_CODES.viewEditLists.code,
  PERMISSION_CODES.useUpdateButton.code
]
